import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ErrorBoundary } from './components/ui/ErrorBoundary.tsx'
import { ToastProvider } from './components/ui/Toast.tsx'
import { ConsentProvider } from './context/ConsentContext.tsx'
import { CookieConsentBanner } from './components/ui/CookieConsentBanner.tsx'
import { AuthProvider } from './context/AuthContext.tsx'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <ToastProvider>
          <ConsentProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
            <CookieConsentBanner />
          </ConsentProvider>
        </ToastProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>
)
